import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';

const LOGO_BLACK = 'https://customer-assets.emergentagent.com/job_additive-factory-3/artifacts/hikohrp1_RD_Logo_Black.png';

const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="bg-zinc-50 border-t border-zinc-200 mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="mb-4">
            <img
              src={LOGO_BLACK}
              alt="ROLVIA DESIGN"
              className="h-20 md:h-24 w-auto object-contain"
              draggable={false}
            />
          </div>
          <p className="text-zinc-600 max-w-md text-sm leading-relaxed">{t.footer.tagline}</p>
        </div>

        <div>
          <h4 className="text-zinc-900 font-semibold mb-4 text-sm uppercase tracking-wider">{t.footer.links}</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-zinc-600 hover:text-orange-500 transition-colors">{t.nav.home}</Link></li>
            <li><Link to="/quote" className="text-zinc-600 hover:text-orange-500 transition-colors">{t.nav.quote}</Link></li>
            <li><Link to="/services" className="text-zinc-600 hover:text-orange-500 transition-colors">{t.nav.services}</Link></li>
            <li><Link to="/about" className="text-zinc-600 hover:text-orange-500 transition-colors">{t.nav.about}</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-zinc-900 font-semibold mb-4 text-sm uppercase tracking-wider">{t.footer.contact}</h4>
          <ul className="space-y-3 text-sm text-zinc-600">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 text-orange-500 mt-0.5" />İstanbul, Türkiye</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-orange-500" />+90 545 453 59 49</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-orange-500" />+90 532 478 02 73</li>
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-orange-500" />info@rolviadesign.com</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 text-xs text-zinc-500 flex flex-col sm:flex-row gap-2 justify-between">
          <span>© {new Date().getFullYear()} ROLVIA DESIGN. {t.footer.rights}</span>
          <span className="text-zinc-400">SLA · SLS · FDM · 3D Printing</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
